import { InputPairContainer } from '../../InputPairContainer';
import { PolicyInputProps } from '../../PolicyInput';
import { ResourceInput } from '../../Resource/ResourceInput';

export type ResourcePairFieldProps = {
  cpu?: { label?: string };
  memory?: { label?: string };
  testId?: string;
} & Pick<PolicyInputProps, 'LabelComponent' | 'variant' | 'size'>;

export const ResourcePairField = ({
  cpu = { label: 'CPU' },
  memory = { label: 'Memory' },
  testId,
  ...inputProps
}: ResourcePairFieldProps) => {
  return (
    <InputPairContainer data-testid={testId}>
      <ResourceInput resource="cpu" label={cpu.label} {...inputProps} />

      <ResourceInput resource="memory" label={memory.label} {...inputProps} />
    </InputPairContainer>
  );
};
